// constants

const SHOW_MAINTENANCE = "SHOW_MAINTENANCE";

// reducers

const initialState = false;

const Maintenance = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MAINTENANCE:
      return true;

    default:
      return state;
  }
};

export default Maintenance;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// export const testCounterDecrement = () => async (dispatch) => {
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   dispatch({
//     type: TEST_COUNTER_DECREMENT,
//   });
// };

// export const testCounterIncrement = () => {
//   return {
//     type: TEST_COUNTER_INCREMENT,
//   };
// };

export const showMaintenance = () => {
  return {
    type: SHOW_MAINTENANCE,
  };
};
